const translations = {
  'developingTeacher.seo.title':
    'Obtenga una visa de estudiante española con nuestro curso TEFL de 12 meses',
  'developingTeacher.seo.description': `Profundiza tus conocimientos con nuestro curso de enseñanza avanzada de 12 meses. Cursos aptos para visados de estudiante de larga duración en España. `,
  'developingTeacher.sec1.title': 'Curso Docente Avanzado',
  'developingTeacher.sec1.description':
    'Desarrolla tus habilidades  docentes con talleres avanzados de enseñanza de inglés y obtén tu visa de estudiante para trabajar y vivir legalmente en España.',
  'developingTeacher.sec1.weeks': '6-12 meses',
  'developingTeacher.sec1.hours': '20 horas por semana de estudio',
  'developingTeacher.sec1.cities': 'Barcelona',
  'developingTeacher.sec2.title': 'Lleva tu enseñanza al siguiente nivel',
  'developingTeacher.sec2.description':
    'El Curso Docente Avanzado es un curso extensivo de desarrollo profesional dirigido a aquellas personas que ya cuentan con cierta formación / experiencia laboral en el mundo TEFL como profesores/as o traductores/as de inglés y desean profundizar su conocimiento y perfeccionar sus habilidades de enseñanza.',
  'developingTeacher.sec2.benefitsTitle': 'Este curso es ideal para ti si:',
  'developingTeacher.sec2.benefit1':
    'Has completado el curso Trinity CertTESOL (o un curso de TEFL similar de 160 horas).',
  'developingTeacher.sec2.benefit2':
    'Eres de Argentina, México, Venezuela (o cualquier otro país no perteneciente a la UE) y deseas calificar para una visa de estudiante.    ',
  'developingTeacher.sec2.benefit3':
    'Deseas profundizar en tu conocimiento de la enseñanza y mejorar tus habilidades.    ',
  'developingTeacher.sec2.key': 'INFORMACIÓN CLAVE:',
  'developingTeacher.sec2.key1.title': '6-12 meses',
  'developingTeacher.sec2.key1.text': 'Duración del curso',
  'developingTeacher.sec2.key2.title': 'Flexible',
  'developingTeacher.sec2.key2.text': 'Fecha de inicio',
  'developingTeacher.sec2.key3.title': '12',
  'developingTeacher.sec2.key3.text': 'Máximo de estudiantes por grupo',
  'developingTeacher.sec2.ben1.title': 'Redes y Apoyo de Compañeros',
  'developingTeacher.sec2.ben1.text':
    'Te conectarás con una gran red de profesores de Barcelona para apoyarse y aprender unos de otros.',
  'developingTeacher.sec2.ben2.title': 'Califica para una Visa de Estudiante',
  'developingTeacher.sec2.ben2.text':
    'La formación que te proporciona este curso avanzado cumple con los requisitos necesarios para obtener tu visado de estudiante.',
  'developingTeacher.sec2.ben3.title': 'Estudia a Tu Propio Ritmo',
  'developingTeacher.sec2.ben3.text':
    'Asiste a talleres centrales cada semana y administra el resto de tus estudios para adaptarse a tu horario.',
  'developingTeacher.sec2.ben4.title': 'Tamaños de Grupos Pequeños',
  'developingTeacher.sec2.ben4.text':
    'Nuestras clases se dictan en grupos reducidos, con lo cual tendrás acceso a una formación personalizada.',

  'developingTeacher.sec3.title': '¿Qué está incluido?',
  'developingTeacher.sec3.benefit1':
    '20 horas por semana de trabajo en el curso (3 horas de sesiones en la escuela por semana).',
  'developingTeacher.sec3.benefit2': 'Tutorías con profesores experimentados.',
  'developingTeacher.sec3.benefit3':
    'Toda la asistencia y el papeleo necesario para procesar tu visa de estudiante.',
  'developingTeacher.sec3.benefit4':
    'Acceso a nuestra hermosa biblioteca escolar, wifi de alta velocidad, computadoras.',
  'developingTeacher.sec3.benefit5':
    'Contactos laborales y asistencia personalizada para ayudarte a encontrar trabajo. ',
  'developingTeacher.sec3.benefit6': 'Acceso a nuestra red de profesores de Barcelona.',
  'developingTeacher.sec3.fullPrice': 'PRECIO COMPLETO',
  'developingTeacher.sec3.discountPrice': 'PRECIO CON DESCUENTO: ',
  'developingTeacher.sec3.payInFull': 'Cuando te registras para 1 año de clases ',
  'developingTeacher.sec3.oneYear': 'por 1 año  ',
  'developingTeacher.sec3.quotation':
    'The staff is amazing with teachers who really care about your future. The course is challenging, but prepares you for the world of teaching English as a second language. They assist you throughout the course with things such as accommodation, finding a job, and visa requirements. I would recommend this school to anyone who wants to become certified or just have an incredible journey in Barcelona.',
  'developingTeacher.sec8.title': 'Plan de estudios y horario del curso',
  'developingTeacher.sec8.description':
    'El curso de Desarrollo de Profesores es una combinación de talleres prácticos y autoestudio. Los talleres tienen lugar en la escuela los <accent>viernes, de 12.30 a 14.00.</accent>',
  'developingTeacher.sec8.notification.title': '¿El inglés no es tu lengua materna?',
  'developingTeacher.sec8.notification.description':
    'Debes demostrar un nivel C1 para poder realizar el curso.',
  'btn.takeEnglisAssessment': 'Prueba nivel de inglés',
  'developingTeacher.btn.downloadTrinitySyllabus':
    'Descarga el plan de estudios del curso de Desarrollo de Profesores',
  'btn.viewMoreFaqs': 'Ver más preguntas frecuentes',
  'common.faqs': 'Preguntas frecuentes ',
  'developingTeacher.sec11.title': 'Otros <accent>cursos populares</accent>',
  'developingTeacher.sec11.description': 'Lleva tu formación al siguiente nivel con TEFL Iberia',
  'developingTeacher.sec11.course1': 'Trinity CertTESOL',
  'developingTeacher.sec11.course2': 'Enseñanza a jóvenes estudiantes',
  'developingTeacher.sec11.course3': 'Intensive Spanish Course',
  'developingTeacher.sec11.month': 'mes',
  'developingTeacher.sec11.days': 'curso de 3 días',
};

export default translations;
